/**
 * Resolves the API base URL from the SPA's current hostname.
 *
 * Production routing:
 *   app.heybesafe.com         -> https://api.heybesafe.com   (live alias)
 *   app-blue.heybesafe.com    -> https://api-blue.heybesafe.com
 *   app-green.heybesafe.com   -> https://api-green.heybesafe.com
 *   app-test.heybesafe.com    -> https://api-test.heybesafe.com
 *   heybesafe.com / www.*     -> https://api.heybesafe.com   (legacy /safe/ path)
 *
 * Local dev (localhost / 127.0.0.1 / unknown host) falls back to the
 * VITE_API_BASE_URL build-time env, defaulting to the live alias if unset.
 *
 * Why runtime, not build-time: a CDK cutover that flips the api.* alias
 * between blue and green should not also require a SPA rebuild + S3 sync.
 * Resolving at runtime means the same SPA bundle in green's bucket talks
 * to api.heybesafe.com when reached via app.heybesafe.com (live traffic)
 * and to api-green.heybesafe.com when reached via app-green.heybesafe.com
 * (pre-cutover testing) — same bundle, two correct destinations.
 */
export function resolveApiBaseUrl(
  hostname: string,
  fallback: string | undefined,
): string {
  if (hostname === 'app.heybesafe.com') return 'https://api.heybesafe.com';
  if (hostname === 'heybesafe.com' || hostname === 'www.heybesafe.com') {
    return 'https://api.heybesafe.com';
  }
  const colorMatch = hostname.match(/^app-(blue|green|test)\.heybesafe\.com$/);
  if (colorMatch) return `https://api-${colorMatch[1]}.heybesafe.com`;
  return fallback ?? 'https://api.heybesafe.com';
}
